
import CustomModal from '~/components/ui/molecule/CustomModal.vue';
import { mapActions, mapGetters } from 'vuex';
import CompanyTagCard from '~/components/ui/molecule/CompanyTagCard.vue';
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import { buildAssetUri } from '~/utils/mixins';

export default {
  name: 'CompanyTickersListModal',
  components: {
    CustomModal,
    CompanyTagCard,
    CloseIcon,
  },
  mixins: [buildAssetUri],
  data() {
    return {
      // Used to trigger the animation in Custom Modal for company's tickers component
      showCompanyTickersListModal: false,
    };
  },
  async fetch() {
    if (this.additionalTickersLoaded) return;
    await this.getAdditionalCompanySymbols({
      companyId: this.profile.profileId,
    });
  },
  computed: {
    ...mapGetters('companyProfile', [
      'getCompanySymbolsRes',
      'getCurrentlyActiveTickerIndex',
      'additionalTickersLoading',
      'additionalTickersLoaded',
    ]),
    ...mapGetters('profile', ['profile']),
  },
  mounted() {
    this.showCompanyTickersListModal = true;
  },
  methods: {
    handleCloseModal() {
      this.showCompanyTickersListModal = false;
      this.$emit('closeModal');
    },
    ...mapActions('modals', ['toggleCompanyTickersListModal']),
    ...mapActions('companyProfile', ['getAdditionalCompanySymbols']),
    handleActiveTickerChange(index) {
      const ticker = this.getCompanySymbolsRes?.data?.[index];
      if (!ticker) return;

      this.toggleCompanyTickersListModal(false);
      this.$nuxt.$emit('profile:ticker-change', ticker);
    },
  },
};
